<template>
  <div class="page-users">
    <PageHeader>
      <h1>All Users <span>({{totalUsers}})</span></h1>

      <Btn primary hasIcon tooltip="Invite User">
        <router-link :to="{name: 'add-user'}">
          <Sprite name="add"/>
        </router-link>
      </Btn>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content">
          <table-data
            :rows="users"
            :headings="[
              {heading: 'Email Address', key: 'user-email'},
              {heading: 'Active', key: 'user-active-status'}
              ]"
            :pagination="pagination">

            <div
              v-for="(user, index) in users"
              :slot="'td-' + index + '-user-email'"
              :key="index">

              <router-link :to="{name: 'user', params: {companyId: user.company_id, userId: user.id}}">
                {{ user.email }}
              </router-link>
            </div>

            <div
              v-for="(user, index) in users"
              :slot="'td-' + index + '-user-active-status'"
              class="user-active-status"
              :key="index">
              <div class="active-state" :class="{ 'is-active': user.active}"></div>
            </div>
          </table-data>

          <pagination @changePage="changePage" :pagination="pageData">
          </pagination>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Global Users</h1>
            <p>
              This page lists all global users on the platform. There are currently <strong>{{totalUsers}}</strong> users but we'll be adding more advanced stats and reporting later.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>

    <router-view/>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'

import {readUsersData} from '@/lib/users'

import Table from '@/components/Table'
import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'
import Sprite from '@/components/Sprite'
import Btn from '@/components/Btn'

export default {
  name: 'users',

  mixins: [page, pagination],

  components: {
    TableData: Table,
    PageHeader,
    PageSummary,
    Sprite,
    Btn
  },

  data() {
    return {
      users: [],
      user: {},
      errors: {},
      title: 'Users'
    }
  },

  methods: {
    getData() {
      readUsersData(this.pagination).then(({data, page}) => {
        this.users = data
        this.pageData = page
      })
    },

    confirmDelete(user) {
      if (confirm('Are you sure you wish to delete this user?')) {
        this.deleteUser(user.id)
      }
    }
  },

  computed: {
    totalUsers() {
      return this.pageData.total_entries
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-users
  @extend %page

.heading-active
  text-align: center

.active-state
  @extend %active-state
</style>
